import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { CONTACT_CONFIG } from '../config/contact';

export default function Use() {
  const contactInfo = CONTACT_CONFIG;
  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Algemene Voorwaarden</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
              >
                Home
              </NavLink>{" "}
              / <span className="text-gray-300">Algemene Voorwaarden</span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Aanvaarding van de voorwaarden
              </h2>
              <p className="text-base leading-relaxed">
                Door toegang te krijgen tot onze website en onze IPTV-diensten te gebruiken,
                gaat u akkoord met deze Algemene Voorwaarden. Als u niet akkoord gaat
                met deze voorwaarden, gelieve onze website of diensten niet te gebruiken.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">2. IPTV-diensten</h2>
              <p className="text-base leading-relaxed">
                feesttv biedt IPTV-abonnementen om u te laten genieten van een breed scala aan
                zenders en inhoud. Deze abonnementen zijn ontworpen om een hoogwaardige
                kijkervaring te bieden zonder dat uw persoonlijke gegevens hoeven te worden verzameld.
                <br />
                Activeringscodes en installatie-instructies worden u direct na uw aankoop verstrekt.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">3. Privacy</h2>
              <p className="text-base leading-relaxed">
                Wij verzamelen geen persoonlijke gegevens van onze gebruikers. Dit betekent dat uw naam,
                adres, betalingsgegevens of andere identificeerbare details niet worden verzameld
                of opgeslagen door feesttv. Uw privacy is gegarandeerd.
              </p>
              <p className="text-base leading-relaxed pt-2">
                Bij het gebruik van onze diensten kunt u er zeker van zijn dat uw activiteiten
                volledig anoniem en veilig blijven.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">4. Betaling</h2>
              <p className="text-base leading-relaxed">
                Betalingen worden verwerkt via beveiligde externe platforms.
                feesttv slaat geen betalingsinformatie op. Volg de verstrekte instructies
                om uw aankoop veilig af te ronden.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                5. Gebruik van de diensten
              </h2>
              <p className="text-base leading-relaxed">
                De door feesttv geleverde IPTV-diensten zijn uitsluitend bedoeld voor persoonlijk gebruik.
                U mag activeringscodes of inhoud die door onze diensten wordt verstrekt niet delen,
                herdistribueren of doorverkopen. Elk misbruik kan leiden tot de beëindiging
                van uw abonnement zonder restitutie.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">6. Aansprakelijkheid</h2>
              <p className="text-base leading-relaxed">
                feesttv zet zich in voor het leveren van hoogwaardige IPTV-diensten.
                We kunnen echter geen ononderbroken beschikbaarheid garanderen vanwege
                externe factoren zoals internetstoringen of technische problemen.
              </p>
            </div>

            {/* Section 7 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                7. Intellectuele eigendomsrechten
              </h2>
              <p className="text-base leading-relaxed">
                Alle inhoud die via onze IPTV-diensten wordt verstrekt, inclusief zenders,
                films en series, is beschermd door auteursrechten en intellectuele eigendomsrechten.
                U mag deze inhoud niet opnemen, distribueren of kopiëren.
              </p>
            </div>

            {/* Section 8 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                8. Wijzigingen van de voorwaarden
              </h2>
              <p className="text-base leading-relaxed">
                Wij behouden ons het recht voor om deze voorwaarden op elk moment te wijzigen.
                Eventuele wijzigingen worden op onze website gepubliceerd. Door onze diensten
                te blijven gebruiken na een wijziging, gaat u akkoord met de nieuwe voorwaarden.
              </p>
            </div>

            {/* Section 9 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">9. Neem contact met ons op</h2>
              <p className="text-base leading-relaxed mb-4">
                Voor vragen over deze algemene voorwaarden of om uw rechten uit te oefenen,
                kunt u contact met ons opnemen via:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>E-mail: {contactInfo.email}</li>
                <li>
                  WhatsApp:{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#00d4ff] underline hover:text-[#090979]"
                  >
                    Klik hier om contact met ons op te nemen
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Bedankt dat u voor {contactInfo.companyName} heeft gekozen. Wij zijn er trots op
                uw privacy te waarborgen en u een hoogwaardige service te bieden.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
